<template >
    <div style="margin-left: 10px">
        <el-button :type="menu.css==''?'primary':menu.css"  @click="handleclick(menu.linkurl)" v-for="menu in menus" :key="menu.id">
            {{menu.name}}
        </el-button>
    </div>
</template>

<script>
export default {
    props: {
        menu_id: {
            type: Number,
            default() {
                return 0
            }
        },
        menus: {
            type: Array,
            default() {
                return 0
            }
        }
    },
    methods: {
        handleclick(params){
            this.$emit('on_btnclk',params);
        },
    }
}
</script>